// extracted by mini-css-extract-plugin
export default {"main":"postpurchase_main__HPJkD","container":"postpurchase_container__LtpPa","verifyEmail":"postpurchase_verifyEmail__fqOqP","listText":"postpurchase_listText__KSo9m"};